import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'stripHtml' })
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if(value !== null){
      return value.replace(/<[^>]*>/g, '');
    }

    return value;
  }
}
